import React, { useEffect, useState } from "react";

const RulesViewer = () => {
  // Serve the PDF from the app's public folder so it can be embedded inline
  const base = "/assets/rules.pdf";
  const [src, setSrc] = useState(base);

  useEffect(() => {
    // Try to read the build/version file produced at build time to use as cache-buster.
    // Fallback to a timestamp if the file isn't available.
    const fetchVersion = async () => {
      try {
        const res = await fetch("/version.json", { cache: "no-store" });
        if (res.ok) {
          const j = await res.json();
          if (j && j.version) {
            setSrc(`${base}?v=${encodeURIComponent(j.version)}`);
            return;
          }
        }
      } catch (e) {
        // ignore
      }
      // final fallback
      setSrc(`${base}?t=${Date.now()}`);
    };

    fetchVersion();
  }, []);

  // Use key={src} to force React to remount the <embed> when src changes,
  // ensuring the browser actually requests the updated PDF instead of
  // reusing a prior embed/document in memory.
  // Render the rules inside a fullscreen overlay with a visible iframe and
  // an explicit "open in new tab" link. This ensures the PDF is reachable
  // even when other fixed overlays or stacking contexts would cover an <embed>.
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        bottom: "var(--navbar-height, 0)",
        left: 0,
        right: 0,
        zIndex: 4000,
        background: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* top toolbar removed as requested */}

      {/* Embed the PDF inline. Using an iframe pointing at a same-origin PDF
          usually lets the browser render it inline. Keep key so changing src
          forces a remount. If iframe fails, the <embed> below acts as a
          progressive fallback in some browsers. */}
      <iframe
        key={src}
        src={src}
        title="Rise Rules"
        type="application/pdf"
        style={{ border: "none", width: "100%", height: "100%", flex: 1 }}
      />

      {/* Embed fallback for browsers that prefer <embed> */}
      <embed src={src} type="application/pdf" style={{ display: "none" }} />
    </div>
  );
};

export default RulesViewer;
